module.exports = __webpack_public_path__ + "static/app-shot-n-1-3-009f60d2aa43d3f50b6329206260bc04.png";